import React from 'react';
import FlowPage from '../../components/flow/FlowPage';
import { useParams } from 'react-router-dom';

const Flows = () => {
    const { id } = useParams();

    return (
        <FlowPage flowId={id}/>
    );
};

export default Flows;